module.exports = __webpack_public_path__ + "static/media/Adobe_XD_CC_icon.c8b85581.svg";